var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3917_61048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 0.333496H5.16406V4.16683H0.333336V0.333496Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 10.8335H5.16406V14.6668H0.333336V10.8335Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 5.5H5.16406V9.33333H0.333336V5.5Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5H10.5V6.66667H5.5V5.5Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5026 0.333614L10.5 0.333496V3.8306L5.5026 3.83071V0.333614Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 0.333614L15.6641 0.333496L15.6667 5.16519L10.8333 5.16531V0.333614Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 10.8336L15.6641 10.8335L15.6667 15.6652L10.8333 15.6653V10.8336Z",
    fill: "#00B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 5.50012L15.6641 5.5L15.6667 10.4999L10.8333 10.5V5.50012Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 1.3335H5.16911L5.16667 5.16378H0.333336V1.3335Z",
    fill: "#00B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 14.5H5.16911L5.16667 15.6667H0.333336V14.5Z",
    fill: "#00B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 8.1665H5.16911L5.16667 9.33317H0.333336V8.1665Z",
    fill: "#00B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333336 9.3335H5.16911L5.16667 10.5002H0.333336V9.3335Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50032 3.3335H10.5L10.4999 5.16391H5.49772L5.50032 3.3335Z",
    fill: "#00B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.3335H10.5V5.16683H5.5V3.3335Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.8335H10.5V12.0002H5.5V10.8335Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12H10.5V15.6667H5.5V12Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.6665H10.5V7.33317H5.5V6.6665Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.3335H10.5V10.5002H5.5V7.3335Z",
    fill: "#00B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16667 0.333333V5.16667H0.333333V0.333333H5.16667ZM0.333333 5.5H5.16667V10.5H0.333333V5.5ZM5.5 5.5V10.5H10.5V5.5H5.5ZM0.333333 10.8333H5.16667V15.6667H0.333333V10.8333ZM5.5 10.8333V15.6667H10.5V10.8333H5.5ZM5.33333 16H5.5H10.5H10.6667H10.8333H15.6667H16V15.6667V10.8333V10.6667V10.5V5.5V5.33333V5.16667V0.333333V0H15.6667H10.8333H10.6667H10.5H5.5H5.33333H5.16667H0.333333H0V0.333333V5.16667V5.33333V5.5V10.5V10.6667V10.8333V15.6667V16H0.333333H5.16667H5.33333ZM15.6667 15.6667H10.8333V10.8333H15.6667V15.6667ZM15.6667 10.5H10.8333V5.5H15.6667V10.5ZM15.6667 5.16667H10.8333V0.333333H15.6667V5.16667ZM5.5 0.333333H10.5V5.16667H5.5V0.333333Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3917_61048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreens);
export default __webpack_public_path__ + "static/media/Screens.cc3217b94e84aac748b1812ec4f419ae.svg";
export { ForwardRef as ReactComponent };